import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeepLinkService } from '../../services/deep-link.service';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '../../components/loader/loader.component';

@Component({
  selector: 'app-deeplink-wrapper',
  templateUrl: './deeplink-wrapper.page.html',
  standalone: true,
  imports: [LoaderComponent, TranslateModule],
})
export class DeeplinkWrapperPage implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private deeplinkService: DeepLinkService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.link) {
        this.deeplinkService.checkLink(params.link);
      }
    });
  }

  ngOnInit() {}
}
